import { UserLayout } from "./components/layout/UserLayout";
import Container from "./components/Container";
import Text from "./components/Text";
import { useFetchPageContentQuery } from "../../stores/api/page-content.api";

const TermsAndConditions = () => {
  const { data, isLoading } = useFetchPageContentQuery("terms");

  return (
    <UserLayout>
      <div className="bg-gray-50 border-b border-gray-100 py-12">
        <Container variant="xnarrow" className="px-6 text-center">
          <Text is="h1" className="text-3xl font-bold text-gray-900 mb-3">
            Terms &amp; Conditions
          </Text>
        </Container>
      </div>

      <Container variant="xnarrow" className="px-6 py-14" isLoading={isLoading}>
        {data?.content ? (
          <div
            className="prose prose-sm max-w-none text-gray-600"
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
        ) : (
          !isLoading && <Text is="p" className="text-sm text-gray-400">No content yet.</Text>
        )}
      </Container>
    </UserLayout>
  );
};

export default TermsAndConditions;
